import { ComponentType as n } from "../../registries/types/propTypes.js";
import t from "../navigation-menu-transformer/navigationMenuTransformer.js";
const i = (o) => ({
  ...t(o),
  componentType: n.shop_by_container,
  hideNavigation: o.hideNavigation
});
export {
  i as default
};
//# sourceMappingURL=shop-by-container-transformer.js.map
